export class ViewInfo {
    constructor(public title = "", public text = "", public icon = "") {
    }

}